var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLike = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  strokeWidth: 2,
  d: "M20.454 23.388c-.956.809-1.982 1.677-3.076 2.624L16 27.186l-1.378-1.174a327 327 0 0 0-3.078-2.626c-2.245-1.899-4.103-3.47-5.538-4.98C3.994 16.286 3 14.471 3 12.314 3 8.792 5.863 6 9.7 6c2.165 0 4.203.943 5.553 2.458l.747.838.747-.838C18.097 6.943 20.135 6 22.3 6c3.837 0 6.7 2.792 6.7 6.315 0 2.157-.994 3.973-3.006 6.09-1.436 1.511-3.294 3.084-5.54 4.983z"
})));
export default SvgIconLike;